import { SkillCategory } from '@applicator/shared'
import React from 'react'

interface SkillsMultiSelectBarProps {
  selectedCount: number
  categories: SkillCategory[]
  moveToCategoryMenu: boolean
  moveMenuRef: React.RefObject<HTMLDivElement>
  onToggleMoveMenu: () => void
  onMoveToCategory: (categoryId: string) => void
  onCreateNewCategoryAndMove: () => void
  onCancel: () => void
}

export default function SkillsMultiSelectBar({
  selectedCount,
  categories,
  moveToCategoryMenu,
  moveMenuRef,
  onToggleMoveMenu,
  onMoveToCategory,
  onCreateNewCategoryAndMove,
  onCancel,
}: SkillsMultiSelectBarProps) {
  if (selectedCount === 0) return null

  return (
    <div className="relative flex items-center justify-between p-2 bg-brand-primary-subtle border border-brand-primary/20 rounded-lg">
      <span className="text-sm text-interactive font-medium">
        {selectedCount} skill{selectedCount !== 1 ? 's' : ''} selected
      </span>
      <div className="flex items-center gap-2">
        <div className="relative">
          <button
            onClick={onToggleMoveMenu}
            className="text-xs px-2 py-1 bg-brand-primary text-white rounded hover:bg-brand-primary-hover"
          >
            Move to Group
          </button>
          {moveToCategoryMenu && (
            <div 
              ref={moveMenuRef}
              className="absolute right-0 mt-1 bg-surface-default border border-border-default rounded-lg shadow-lg p-2 max-h-48 overflow-y-auto z-50 min-w-[150px]"
            >
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => onMoveToCategory(cat.id)}
                  className="block w-full text-left px-2 py-1 text-sm hover:bg-surface-muted rounded"
                >
                  {cat.name || 'Unnamed Category'}
                </button>
              ))}
              <button
                onClick={onCreateNewCategoryAndMove}
                className="block w-full text-left px-2 py-1 text-sm text-interactive hover:bg-surface-muted rounded mt-1"
              >
                + New Group
              </button>
            </div>
          )}
        </div>
        <button
          onClick={onCancel}
          className="text-xs px-2 py-1 bg-surface-muted text-text-secondary rounded hover:bg-surface-muted"
        >
          Cancel
        </button>
      </div>
    </div>
  )
}
